module.exports = __webpack_public_path__ + "static/media/avec_logo.8a5836f4.png";